import React from 'react'
// TODO move ui
// import { Section } from '@brainstud/schiphol-vtc-ui'
import { ReactComponent as PaperClip } from '../shared/assets/paperclip.svg'
import styles from './Intro.module.css'

const Intro = props => (
  <div className={styles.base}>
    <div className={styles.header}>
      <div className={styles.headerTitle}>{props.title}</div>
    </div>

    <Section>
      <div className={styles.info}>
        <div className={styles.infoRules}>
          <div className={styles.paperclip}>
            <PaperClip />
          </div>

          {props.side}
        </div>

        <div className={styles.infoText}>
          {props.main}
        </div>
      </div>
    </Section>
  </div>
)

export default Intro
